import { generateUtilityClass } from '../generateUtilityClass';
import { generateUtilityClasses } from '../generateUtilityClasses';
const COMPONENT_NAME = 'Input';
export function getInputUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME, slot);
}
export const inputClasses = generateUtilityClasses(COMPONENT_NAME, ['root', 'formControl', 'focused', 'disabled', 'error', 'multiline', 'input', 'inputMultiline', 'inputTypeSearch', 'adornedStart', 'adornedEnd']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/Input/inputClasses.js
// module id = 1107
// module chunks = 0